import { ProductDeliveryPromiseExplanations, ProductTileVerticalFormat } from './product-detail/ProductTypes';

export type ProductGroupMonetateOwnProps = {
  collapsed?: boolean;
  collapsible: boolean;
  containerId: string;
  deliveryPromiseExplanations?: ProductDeliveryPromiseExplanations;
  tileFormat?: ProductTileVerticalFormat;
  title?: string;
};

export type MonetateRecommendations = {
  actionId: number;
  recommendations: Array<MonetateRecommendation>;
};

export type MonetateRecommendation = {
  productcode: string;
};
